import React from 'react';
import { connect, useDispatch } from 'react-redux';
import _ from 'lodash';
import { t } from 'i18next';
import { getOnboardingState, getAuthState } from '../../../store/selectors';
import { removeCareerPathChoice } from '../../../store/actions';
import { fireGTM } from '../../../gtm/gtmUtil';
import { degreePairingPage_GTM } from '../../../gtm/datalayers/degreePairingDataLayers.json';

// Return a specific career tab/card to it's original state WITHOUT a career path selected
function DeselectPath(props) {
  const dispatch = useDispatch();

  const deselectPathText = {
    color: '#FFFFFF',
  };

  // Return this tab/card to it's original state
  // Remove pairing from DB
  const handlePathDeselected = () => {
    const tempDeselectPathGTM = Object.assign(
      {},
      degreePairingPage_GTM.deselectPath
    );

    tempDeselectPathGTM.component =
      props.onboarding.careerChoices[props.tabNumber].titleEn;
    tempDeselectPathGTM.section =
      props.onboarding.degreeChoices[props.tabNumber].titleEn;
    fireGTM(tempDeselectPathGTM);

    dispatch({
      type: 'SET_CAREER_TAB',
      payload: {
        careerInfo: {
          ...props.onboarding.degreeChoices,
          [props.tabNumber]: '',
        },
        careerTabSelected: false,
        currentTab: 0,
      },
    });

    // Reset all the values of careerCardsExpanded to 'false' so the Progress Bar will display
    const careerCardsExpandedReset = _.mapValues(
      props.onboarding.careerCardsExpanded,
      () => false
    );

    // If a card was expanded then this would shrink it and redisplay the Progress Bar
    dispatch({
      type: 'SHOW_PROGRESS_BAR',
      payload: {
        careerCardsExpanded: {
          ...careerCardsExpandedReset,
        },
      },
    });

    const singlePathDeselectedObject = {
      // Temporary way of using a careerId
      // TODO: Get careerId for the this specific CareerCard from the store
      careerId: props.onboarding.careerChoices[props.tabNumber].id,
    };

    // Need to send careerId and chosen order
    props.removeCareerPathChoice(
      props.tenant.id,
      singlePathDeselectedObject,
      props.auth.jwtToken
    );
  };

  // Return a career card to the original state that shows the 'Build your career path' button
  return (
    <button
      className="deselect-path-text"
      onClick={() => handlePathDeselected()}
      onKeyDown={(e) => {
        if (['Enter'].includes(e.key)) handlePathDeselected();
      }}
      type="button"
      tabIndex={0}
      style={deselectPathText}
      data-cy="remove-path-link"
      aria-label={t('Deselect path {{degreeName}} from this career', {
        degreeName: props.onboarding.degreeChoices[props.tabNumber].titleEn,
      })}
    >
      {t('Deselect path', { context: 'action' })}
    </button>
  );
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);

  return { onboarding, auth };
}

export default connect(mapStateToProps, { removeCareerPathChoice })(
  DeselectPath
);
